import {Button} from '@hm/fundamental'
import {mdiDeleteOutline} from '@mdi/js'
import React from 'react'

import {RolePayerLookupChip} from '../../components/Role/RolePayerLookupChip'
import {GroupedRoleAssignment} from '../../modules/ManageUsers.selectors'

type PayersProps = {
  groupedRoleAssignment: GroupedRoleAssignment
  isEditing: boolean
  handleDeletePayer?(payerId: string): void
  setShowAnotherCustomerOrPayerDropdown?: (show: boolean) => void
}

export const Payers = ({
  groupedRoleAssignment,
  isEditing,
  handleDeletePayer,
  setShowAnotherCustomerOrPayerDropdown
}: PayersProps) => {
  const {payerIds} = groupedRoleAssignment.variantDataScopes

  if (!payerIds || payerIds.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-2">
      {groupedRoleAssignment.variantDataScopes.payerIds?.map((payerId) => (
        <div key={payerId} className="flex gap-2">
          <div className="flex-1 border-1px border-border_highlight_10 rounded-lg py-2 px-3 flex flex-col items-start">
            <RolePayerLookupChip key={payerId} payerId={payerId} />
          </div>
          {isEditing && (
            <Button
              variant="secondary"
              icon={mdiDeleteOutline}
              type="button"
              onClick={() => {
                handleDeletePayer?.(payerId)
                setShowAnotherCustomerOrPayerDropdown &&
                  setShowAnotherCustomerOrPayerDropdown(false)
              }}
            >
              Remove
            </Button>
          )}
        </div>
      ))}
    </div>
  )
}
